

import { ref } from "vue";
import moment from 'moment';

export default {
  name: "romaneio-table",
  components: {

  },
    props: {
      pedidos: {
        type: Array,
        default: () => {
          [];
        },
      },
      doUpdate: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
    },
    data() {
    return {
      por_pagina : false,
      isLast: false,
    }
  },
    setup(props:any) {
      // Acessando as props diretamente sem usar `this`



      // Variáveis reativas para as tags
    //const tags = ref<string[]>([]);
    //const newTag = ref<string>("");

      const fDate = (date:any) => {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      }

      const addTag = (pedido:any) => {
        console.log(pedido.textTag)
        if(!pedido.embalagens)pedido.embalagens = [];
        if (pedido.textTag.trim() !== "" && !pedido.embalagens.includes(pedido.textTag)) {
          pedido.embalagens.push(pedido.textTag.trim());
          pedido.textTag = ""; // Limpa o campo após adicionar
        }
      };

      const doUpdate = (capacidade: any, pedido: any) => {
          props.doUpdate(capacidade, pedido); // Define o novo cen tro do mapa
      };
      // Retorna os métodos ou variáveis que você quer expor
      return {
        //newTag,
        fDate,
        addTag,
        doUpdate,
      };
    },

};
